import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListModels from './ListModels';
import Heading from './Heading';
import { MAPPING } from '../helpers';
import { fetchZipCodeAsync } from '../store/inventory-near-you/reducer';
import { statusSelector } from '../store/inventory-near-you/selector';
import { IDLE_STATUS } from '../../../../constants';
import ErrorMessage from './ErrorMessage';
import Loading from './Loading';

const { linkView, linkViewText } = MAPPING;

const InventoryNearYou = () => {

  const dispatch = useDispatch();
  const status = useSelector(statusSelector);

  useEffect(() => {
    dispatch(fetchZipCodeAsync());
  }, [dispatch]);

  return (
    <>
      <Heading />
      <ListModels />
      <div className="relative" style={{ minHeight: status === IDLE_STATUS ? '' : '300px' }}>
        <ErrorMessage />
        <Loading />
      </div>
      <div className="mx-auto text-center xl:hidden mt-20 lg:mt-0 xl:mt-20">
        <a className="btn btn-ani btn-outline-primary m-0" href={linkView}>
          {linkViewText}
          <span className="relative overflow-hidden inline-flex">
            <span className="icomoon icon-arrow-right-animation" aria-hidden="true" />
            <span className="icomoon icon-arrow-right-animation absolute -left-11" aria-hidden="true" />
          </span>
        </a>
      </div>
    </>
  );
};

export default InventoryNearYou;